import * as yup from 'yup';
import isValidCPF from './validateCpf';
import validateCardValidDate from './validateCardDate';
import * as Errors from '@/constants/error-messages';
import validateName from './validateName';

const validationCustomerPersonalSchema = yup
  .object({
    name: yup
      .string()
      .required('Este nome não é válido.')
      .test('Name validation', Errors.INVALID_NAME, name => validateName(name)),
    birth_date: yup
      .string()
      .required(Errors.INVALID_DATE_SMALL)
      .length(10, Errors.INVALID_DATE_SMALL),
    cpf: yup
      .string()
      .required(Errors.INVALID_CPF)
      .length(14, Errors.INVALID_CPF)
      .test('Cpf validation', Errors.INVALID_CPF, cpf => isValidCPF(cpf)),
    email: yup
      .string()
      .email('Este e-mail não é válido.')
      .required(Errors.REQUIRED_INFORMATION),
    phone: yup
      .string()
      .required(Errors.INVALID_PHONE)
      .length(15, Errors.INVALID_PHONE),
  })
  .required();

const validationCustomerAddressSchema = yup
  .object({
    cep: yup
      .string()
      .required(Errors.REQUIRED_INFORMATION)
      .length(9, 'O CEP deve possuir 9 caracteres.'),
    street: yup
      .string()
      .required('Esta rua não é válida.')
      .min(1, 'Informação inválida.'),
    number: yup
      .string()
      .typeError(Errors.REQUIRED_INFORMATION)
      .required(Errors.REQUIRED_INFORMATION),
    complement: yup.string(),
    district: yup.string().required('Este bairro não é válido.'),
    city: yup.string().required(Errors.REQUIRED_INFORMATION),
    state: yup.string().required(Errors.REQUIRED_SELECTION),
  })
  .required();

const validationCustomerCardSchema = yup
  .object({
    card_number: yup
      .string()
      .required(Errors.INVALID_NUMBER)
      .min(13, Errors.INVALID_NUMBER)
      .max(22, Errors.INVALID_NUMBER),
    card_valid_date: yup
      .string()
      .required(Errors.INVALID_DATE_BIG)
      .length(5, Errors.INVALID_DATE_BIG)
      .test('Date validation', Errors.INVALID_DATE_SMALL, date =>
        validateCardValidDate(date),
      )
      .typeError(Errors.INVALID_DATE_SMALL),
    card_client_name: yup
      .string()
      .required(Errors.REQUIRED_INFORMATION)
      .min(1, Errors.REQUIRED_INFORMATION)
      .test('Name validation', Errors.INVALID_NAME, name => validateName(name)),
    card_cvv: yup
      .string()
      .required(Errors.INVALID)
      .min(3, Errors.INVALID)
      .max(4, Errors.INVALID),
    installments: yup.string().required(Errors.REQUIRED_SELECTION),
  })
  .required();

export {
  validationCustomerPersonalSchema,
  validationCustomerAddressSchema,
  validationCustomerCardSchema,
};
